// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2xB9Q","tab":"ProcedureTabs_tab__3L6mF"};